import GmailIcon from "./GmailIcon.vue";
import WebDeIcon from "./WebDeIcon.vue";
import OutlookIcon from "./OutlookIcon.vue";
import YahooIcon from "./YahooIcon.vue";
import FreenetIcon from "./FreenetIcon.vue";
import TOnlineIcon from "./TOnlineIcon.vue";
import GmxIcon from "./GmxIcon.vue";
import AolIcon from "./AolIcon.vue";
import AppleMailIcon from "./AppleMailIcon.vue";
import MailComIcon from "./MailComIcon.vue";

export default {
    GmailIcon,
    WebDeIcon,
    OutlookIcon,
    YahooIcon,
    FreenetIcon,
    TOnlineIcon,
    GmxIcon,
    AolIcon,
    AppleMailIcon,
    MailComIcon,
};
